export default __webpack_public_path__ + "static/media/FRASES_04.7e76455c.png";